if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        //--------------------------Omair-----------------
        window.isExciseSyncing = true;
        disableCheckoutButton();

        const userProvince = localStorage.getItem('userProvince');
        if (!userProvince) {
          alert('Please select a province before adding to cart.');
          this.highlightProvinceSelection();
          enableCheckoutButton();
          window.isExciseSyncing = false;
          return;
        }

        if (userProvince === "QC" || userProvince === "NS") {
          console.log("Dataset: ", this.dataset);
          const isFlavoured = this.dataset.isFlav === 'true';
          console.log("Button Dataset: ", this.submitButton?.dataset);
          const isFlavouredProduct = this.submitButton?.dataset.isFlavouredProduct === 'true';
          console.log("Is Flavoured Collection: ", isFlavoured);
          console.log("Is Flavoured Product: ", isFlavouredProduct);
          if (isFlavoured) {
            alert('This product is not available for sale in ' + (userProvince === 'NS' ? 'Nova Scotia.' : 'Quebec.'));
            this.submitButton.setAttribute('data-loading', 'false');
            enableCheckoutButton();
            window.isExciseSyncing = false;
            return;
          } else {
            if (isFlavouredProduct) {
              alert('This product is not available for sale in ' + (userProvince === 'NS' ? 'Nova Scotia.' : 'Quebec.'));
              this.submitButton.setAttribute('data-loading', 'false');
              enableCheckoutButton();
              window.isExciseSyncing = false;
              return;
            }
          }
        }
        //--------------------------Omair-----------------

        // === BUNDLE FLAVOUR VALIDATION ===
        // Search the whole document, not just the form, because the
        // bundle selector sits outside the <form> tag in the HTML
        const bundleScope = this.closest('.product__info-container') || this.closest('.card-wrapper');
        const bundleSelector = bundleScope
          ? bundleScope.querySelector('.bundle-flavour-selector')
          : document.querySelector('.bundle-flavour-selector');

        if (bundleSelector) {
          const dropdowns = bundleSelector.querySelectorAll('.bundle-flavour-dropdown');
          const bundleError = bundleSelector.querySelector('.bundle-flavour-error');
          let allSelected = true;

          dropdowns.forEach((dd) => {
            if (!dd.value) {
              allSelected = false;
              dd.classList.add('is-invalid');
              dd.setAttribute('aria-invalid', 'true');
            } else {
              dd.classList.remove('is-invalid');
              dd.removeAttribute('aria-invalid');
            }
          });

          if (bundleError) bundleError.hidden = allSelected;

          if (!allSelected) {
            const firstEmpty = Array.from(dropdowns).find((dd) => !dd.value);
            if (firstEmpty) {
              firstEmpty.scrollIntoView({ behavior: 'auto', block: 'center' });
              // The product form is rendered with novalidate (Dawn default), so the
              // browser's own "required" message only appears if we ask for it.
              if (typeof firstEmpty.reportValidity === 'function') {
                firstEmpty.reportValidity();
              } else {
                firstEmpty.focus({ preventScroll: true });
              }
            }
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            enableCheckoutButton();
            window.isExciseSyncing = false;
            return;
          }
        }
        // === END BUNDLE VALIDATION ===

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // === BUNDLE FLAVOUR PROPERTIES ===
        if (bundleSelector) {
          const dropdowns = bundleSelector.querySelectorAll('.bundle-flavour-dropdown');

          dropdowns.forEach((dd, index) => {
            formData.append(`properties[Flavour ${index + 1}]`, dd.value);
          });

          formData.append('properties[_bundle_pack_size]', dropdowns.length.toString());
        }
        // === END BUNDLE PROPERTIES ===

        //--------------------------Omair-----------------
        const productId = formData.get('id');
        const addQuantity = parseInt(formData.get('quantity')) || 1;

        console.log("🟢 Add-to-cart Submitted", productId, "→ Quantity to add:", addQuantity);

        // Collect bundle flavour variant IDs and their tax status BEFORE fetch
        const bundleFlavourProducts = [];
        if (bundleSelector) {
          const dropdowns = bundleSelector.querySelectorAll('.bundle-flavour-dropdown');
          dropdowns.forEach((dd) => {
            const selectedOption = dd.options[dd.selectedIndex];
            const flavourVariantId = selectedOption?.dataset?.productId;
            const flavourProductType = selectedOption?.dataset?.productType;
            const hasExciseTag = selectedOption?.dataset?.hasExciseTag === 'true';
            if (flavourVariantId) {
              bundleFlavourProducts.push({
                id: flavourVariantId,
                type: flavourProductType,
                hasExciseTag: hasExciseTag,
                element: dd
              });
            }
          });
        }

        // Wait for Shopify to add product to cart then sync excise tax
        setTimeout(async () => {
          // FIRST: Check if main product itself is taxable (bundle parent)
          const mainProductScriptTag = document.querySelector(`.excise-product-meta[data-product-id="${productId}"]`);
          const isMainProductTaxable = mainProductScriptTag !== null;
          
          if (isMainProductTaxable) {
            // Main bundle product has its own excise tax
            console.log(`🧮 Bundle main product is taxable, syncing excise for quantity: ${addQuantity}`);
            await handleExciseTaxAddition(productId, addQuantity);
          }
          
          // SECOND: Check each flavour product for tax
          if (bundleFlavourProducts.length > 0) {
            console.log(`🧮 Bundle: checking ${bundleFlavourProducts.length} flavour products for tax`);
            
            // Track which products we've already added tax for (to avoid duplicates)
            const processedTaxProducts = new Set();
            
            for (const flavour of bundleFlavourProducts) {
              // Check if this flavour product has an excise script tag
              const flavourScriptTag = document.querySelector(`.excise-product-meta[data-product-id="${flavour.id}"]`);
              
              if (flavourScriptTag && !processedTaxProducts.has(flavour.id)) {
                // Each flavour product may need its own tax line item
                // Quantity = pack quantity (addQuantity) for each flavour in the bundle
                console.log(`🧮 Flavour product ${flavour.id} is taxable, adding excise for quantity: ${addQuantity}`);
                await handleExciseTaxAddition(flavour.id, addQuantity);
                processedTaxProducts.add(flavour.id);
              } else if (flavour.hasExciseTag && !processedTaxProducts.has(flavour.id)) {
                // Fallback: if the dataset indicates it has excise tag but no script tag found yet
                console.log(`🧮 Flavour product ${flavour.id} has excise tag, attempting to add tax for quantity: ${addQuantity}`);
                await handleExciseTaxAddition(flavour.id, addQuantity);
                processedTaxProducts.add(flavour.id);
              }
            }
          }
          
          // If no taxable products found, log for debugging
          const mainTaxable = isMainProductTaxable;
          const flavourTaxable = bundleFlavourProducts.some(f => 
            document.querySelector(`.excise-product-meta[data-product-id="${f.id}"]`) !== null || f.hasExciseTag
          );
          
          if (!mainTaxable && !flavourTaxable) {
            console.warn(`⚠️ Bundle product ${productId} and none of its flavours have excise tax configured`);
          }
        }, 1200);
        //--------------------------Omair-----------------

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            console.log("product form finally — excise will enable checkout when done");
            // ✅ Do NOT call disableCheckoutButton() here — it fights
            // against enableCheckoutButton() called inside handleExciseTaxAddition
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      // Highlight province selection if it isn't selected
      highlightProvinceSelection() {
        const provinceSelect = document.getElementById('newProvinceSelect');
        if (provinceSelect) {
          provinceSelect.style.border = '2px solid red';
          provinceSelect.style.boxShadow = '0 0 4px red';
          provinceSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            provinceSelect.style.border = '';
            provinceSelect.style.boxShadow = '';
          }, 3000);
        }
      }
    }
  );
}